import { OrganizationCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/organization_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type OrganizationCreatedDetailProps = {
  event: OrganizationCreatedEvent;
};

export const OrganizationCreatedDetail = ({
  event,
}: OrganizationCreatedDetailProps) => {
  const organization = event.organization;

  if (!organization) {
    return (
      <Col className="@OrganizationCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const onboardedAtStr = protoTimestampToZonedDateTimeString(
    organization.onboardedAt,
  );
  const createdAtStr = protoTimestampToZonedDateTimeString(
    organization.createdAt,
  );

  return (
    <Col className="@OrganizationCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Organization Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={organization.id?.value} />
          <FieldDisplay label="IDP ID" value={organization.idpId} />
          <FieldDisplay label="Name" value={organization.name} />
          <FieldDisplay label="Domain" value={organization.domain} />
          <FieldDisplay label="Timezone" value={organization.timezone?.name} />
          {onboardedAtStr && (
            <FieldDisplay
              label="Onboarded At"
              value={humanReadableDateTime(onboardedAtStr, {
                locale: getLocale(),
              })}
            />
          )}
          {createdAtStr && (
            <FieldDisplay
              label="Created At"
              value={humanReadableDateTime(createdAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
